import { ListFilter } from 'lucide-react';

import { NodeShell } from './NodeShell';

import type { CollectNodeData } from '@repo/shared-types';

export const CollectNode = ({ data, selected }: { data: CollectNodeData; selected?: boolean }) => {
  const filterCount = data.filters?.length ?? 0;
  const subtitle = [
    data.entity,
    filterCount > 0 ? `${filterCount} filter${filterCount === 1 ? '' : 's'}` : null,
    data.outputKey ? `→ ${data.outputKey}` : null,
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <NodeShell
      type="collect"
      icon={<ListFilter size={16} />}
      label={data.label}
      subtitle={subtitle || undefined}
      selected={selected}
    />
  );
};
